import Uri from 'urijs';

import { getNonWwwHostname } from '../../../utils/getNonWwwHostname';
import { isServerside } from '../../utils/isServerside';

import allSites from './allSites';
import { defaultSite } from './defaultSite';
import { TechRadar } from './definitions/TechRadar';
import { TechRadarPro } from './definitions/TechRadarPro';
import type { Site } from './Site';

const getMatchRules = ({
  requestedSite,
  href,
}: {
  requestedSite?: string;
  href?: string;
}): ((site: Site) => boolean)[] => {
  if (requestedSite) {
    // Explicitly requested sites
    return [(site: Site): boolean => requestedSite.toLowerCase() === site.id];
  }

  if (href) {
    const uri = new Uri(href);
    const hostname = uri.hostname();
    const path = uri.path();

    return [
      // Production sites (techradar.com, practicalcaravan.com),
      // Local FTE (local.techradar.com),
      // Localized FTE (global.techradar.com),
      // Staging FTE (techradar.com.master.van-qa.futureplc.engineering)
      // Staging localized FTE (global.techradar.com.master.van-qa.futureplc.engineering)
      (site: Site): boolean => site.hostname !== undefined && hostname.includes(site.hostname),
      // Unconventional staging URLs (for MVC)
      (site: Site): boolean =>
        site.hostnameStage !== undefined && getNonWwwHostname(href) === site.hostnameStage,
      // CMS preview
      (site: Site): boolean => new RegExp(`preview.vanilla.tools/[^/]+/${site.id}`).test(href),
      // Playground and Cypress pages
      (site: Site): boolean => path.includes(`/${site.id}/`),
    ];
  }

  return [];
};
const getSite = ({
  requestedSite,
  href,
  keywords,
}: {
  requestedSite?: string;
  href?: string;
  keywords?: string[];
}): Site => {
  // Playground URL rewriting
  if (!isServerside() && window.hawk_force_url !== undefined) {
    href = window.hawk_force_url;
  }

  const matchRules = getMatchRules({ requestedSite, href });

  const site =
    matchRules.reduce<Site | undefined>((found, rule) => {
      if (found) {
        return found;
      }
      return allSites.find((site) => rule(site));
    }, undefined) ?? defaultSite; // TODO(Petr): HAWK-7560

  // TODO(Petr): HAWK-7560
  // if (!site) {
  // throw new Error(`No site found for requestedSite: ${requestedSite} and href: ${href}`);
  // }

  if (site === TechRadar && keywords?.includes('TRBC')) {
    return TechRadarPro;
  }
  return site;
};

export default getSite;
